import axios from 'axios'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import LoadingSpinner from '../../../components/LoadingSpinner'
import ArrowGoBackSignUp from '../../../components/SignUp/ArrowGoBackSignUp/ArrowGoBackSignUp'
import ImageSignUp from '../../../components/SignUp/ImageSignUpProcess/ImageSignUpProcess'
import NextButton from '../../../components/UIcomponents/NextButton/NextButton'
import WebCamID from '../../../components/WebCamID/WebCamID'
import { RootState } from '../../../redux/store/store'
import { putIdImgByUserId, uploadedUserIdImage } from '../../../utils/requestsUtils/functionsRequests/user/userFunctions'

const VideoIdScreen = () => {

    const navigate = useNavigate()

    const userId = useSelector((state: RootState) => state.auth.user.id)


    const [loading, setLoading] = useState(false)

    const [error, setError] = useState("")

    const onNext = useCallback(
        () => {
            navigate("/select-profile")
        },
        [],
    )

    const goBack = useCallback(
        () => {
            navigate(-1)
        },
        [],
    )

    const onFinishRecord = useCallback(
        (blob: Blob) => {
            setLoading(true)
            putIdImgByUserId("Video_id")
            .then((url) => {
                const options = { headers: { 'Content-Type': "image/*, video/*" } };
                axios.put(url, blob, options)
                .then(() => {
                    uploadedUserIdImage(userId)
                    .then(() => {
                        onNext()
                    }).catch(() => {
                        
                    }).finally(() => {
                        setLoading(false)
                    })
  
                }).catch(() => {
                    setLoading(false)
                })
            }).catch(() => {
                setLoading(false)
            })
        },
        [],
    )
    

    return (
        <div className="width-100  height-100 flex flex-d-column flex-jc-sb" style={{ marginBottom: "0px" }}>

            <div className="flex flex-jc-sb flex-ai-center" style={{ marginTop: "11.5vh" }}>
                <div className="" style={{ width: "35%" }}>

                   
                    <p className="fs-36-vh c-text" style={{ marginBottom: "2.2vh" }}>{"Upload your video ID"}</p>

                    <p className="fs-22-vh c-text" style={{ marginBottom: "4.4vh" }}>{"Help us to secure our community"}</p>

                    <WebCamID onFinishRecord={onFinishRecord} />

                    <div className="p-relative">
                        <p className="p-absolute color-error fs-12 mt-6">
                            {error}
                        </p>
                    </div>

                    <p className="fs-18-vh c-text" style={{ marginTop: "4.4vh" }}>{"Upload the front and back of your ID Card, Passepport or Drive licence."}</p>
                </div>

                { ImageSignUp["Id"] }
            </div>

            <div className="flex flex-jc-sb" style={{ marginBottom: "12.2vh" }}>
                <ArrowGoBackSignUp onPress={goBack} />

                <NextButton 
                    onPress={onNext} 
                    text={"Skip"} 
                />
            </div>

            { loading && <LoadingSpinner fullPage={true} /> }

        </div>
    )
}

export default VideoIdScreen